import { ICreateAndUpdateMunicipality } from "../../../types/municipality.interface";
import customAxios from "../../customAxios";
import { UPDATE_MUNICIPALITY } from "../../routes";
// import { PAY_DEBT_BY_ADMIN_PUT } from "../../routes";

const updateMunicipality = async (props: ICreateAndUpdateMunicipality) => {
  console.log(props);

  const body = {
    userName: props?.userName,
    password: props?.password,
    name: props?.name,
    cities: props?.cities,
  };

  try {
    return (await customAxios.put(UPDATE_MUNICIPALITY + `/${props._id}`, body))
      .data;
  } catch (error: unknown) {
    console.error({ UPDATE_MUNICIPALITY: error });
    return false;
  }
};

export default updateMunicipality;
